var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "calendar-view",
        {
          attrs: {
            events: _vm.events,
            "show-date": _vm.showDate,
            "enable-drag-drop": false,
            "starting-day-of-week": 1,
            "disable-past": true,
            "event-top": "25px",
          },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function (ref) {
                var headerProps = ref.headerProps
                return _c(
                  "div",
                  {
                    staticClass: "text-center mb-5",
                    on: {
                      input: function ($event) {
                        return _vm.setShowDate()
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "d-inline-flex align-items-center" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "mt-1",
                            attrs: {
                              type: "button",
                              disabled: !headerProps.previousPeriod,
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.setShowDate(
                                  headerProps.previousPeriod
                                )
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "icon-arrow-long-left icon-xsm",
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "h6",
                          {
                            staticClass:
                              "font-weight-light text-darker text-uppercase ls-04 mx-5",
                            attrs: { slot: "label" },
                            slot: "label",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(headerProps.periodLabel) +
                                "\n        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "mt-1",
                            attrs: {
                              type: "button",
                              disabled: !headerProps.nextPeriod,
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.setShowDate(headerProps.nextPeriod)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "icon-arrow-long-right icon-xsm",
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              },
            },
            {
              key: "dayContent",
              fn: function (ref) {
                var day = ref.day
                return _c(
                  "div",
                  {
                    ref: _vm.formatDay(day),
                    staticClass: "day-card",
                    class: { "small-device": _vm.viewportWidth <= 991 },
                  },
                  [
                    _c("div", { staticClass: "text-all-day" }, [
                      _c("span", { staticClass: "month" }, [
                        _vm._v(
                          _vm._s(
                            day.toLocaleString("default", { month: "short" })
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "day-number" }, [
                        _vm._v(_vm._s(day.getDate())),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "day" }, [
                        _vm._v(
                          _vm._s(
                            day.toLocaleDateString("default", {
                              weekday: "short",
                            })
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn-all-day-xs",
                        attrs: {
                          type: "button",
                          disabled: _vm.isReserved(day, "all-day"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openBookModal(day, null)
                          },
                        },
                      },
                      [
                        _vm.isReserved(day, "morning")
                          ? _c("span", { staticClass: "reserved-morning" })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isReserved(day, "evening")
                          ? _c("span", { staticClass: "reserved-evening" })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", { staticClass: "day-number" }, [
                          _vm._v(_vm._s(day.getDate())),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "btns-book-calendar-wrapper" }, [
                      _c("p", { staticClass: "book" }, [_vm._v("BOOK FOR:")]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-book-calendar",
                          attrs: {
                            type: "button",
                            disabled:
                              _vm.isReserved(day, "morning") ||
                              _vm.isReserved(day, "all-day"),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.openBookModal(day, "morning")
                            },
                          },
                        },
                        [_c("span", [_vm._v("MORNING")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-book-calendar",
                          attrs: {
                            type: "button",
                            disabled:
                              _vm.isReserved(day, "evening") ||
                              _vm.isReserved(day, "all-day"),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.openBookModal(day, "evening")
                            },
                          },
                        },
                        [_c("span", [_vm._v("EVENING")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-book-calendar",
                          attrs: {
                            type: "button",
                            disabled:
                              _vm.isReserved(day, "morning") ||
                              _vm.isReserved(day, "evening") ||
                              _vm.isReserved(day, "all-day"),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.openBookModal(day, "all-day")
                            },
                          },
                        },
                        [_c("span", [_vm._v("ALL DAY")])]
                      ),
                    ]),
                  ]
                )
              },
            },
          ]),
        },
        [
          _vm._v(" "),
          _vm._v(" "),
          _c("div", {
            staticClass: "d-none",
            attrs: { slot: "event" },
            slot: "event",
          }),
        ]
      ),
      _vm._v(" "),
      _vm._m(0),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "memo d-sm-none mt-5 px-sm-0 px-2" }, [
      _c("div", { staticClass: "block" }, [
        _c("span", { staticClass: "icon" }),
        _vm._v(" "),
        _c("p", [_vm._v("ALL-DAY RESERVED")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "block" }, [
        _c("span", { staticClass: "icon icon-morning" }),
        _vm._v(" "),
        _c("p", [_vm._v("MORNING RESERVED")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "block" }, [
        _c("span", { staticClass: "icon icon-evening" }),
        _vm._v(" "),
        _c("p", [_vm._v("EVENING RESERVED")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }